export default {

    land:[
        {
            "y": 0
        },
        {
            "y": 0.63
        },
        {
            "y": 0.64
        },
        {
            "y": 0.65
        },
        {
            "y": 0.66
        },
        {
            "y": 0.68
        },
        {
            "y": 0.69
        },
        {
            "y": 0.71
        },
        {
            "y": 0.73
        },
        {
            "y": 0.74
        },
        {
            "y": 0.76
        },
        {
            "y": 0.78
        },
        {
            "y": 0.8
        },
        {
            "y": 0.82
        },
        {
            "y": 0.84
        },
        {
            "y": 0.86
        },
        {
            "y": 0.88
        },
        {
            "y": 0.9
        },
        {
            "y": 0.91
        },
        {
            "y": 0.93
        },
        {
            "y": 0.96
        },
        {
            "y": 0.99
        },
        {
            "y": 1
        },
        {
            "y": 1.03
        },
        {
            "y": 1.05
        },
        {
            "y": 1.07
        },
        {
            "y": 1.1
        },
        {
            "y": 1.12
        },
        {
            "y": 1.15
        },
        {
            "y": 1.18
        },
        {
            "y": 1.21
        },
        {
            "y": 1.23
        },
        {
            "y": 1.26
        },
        {
            "y": 1.29
        },
        {
            "y": 1.32
        },
        {
            "y": 1.35
        },
        {
            "y": 1.38
        },
        {
            "y": 1.42
        },
        {
            "y": 1.45
        },
        {
            "y": 1.49
        },
        {
            "y": 1.52
        },
        {
            "y": 1.55
        },
        {
            "y": 1.59
        },
        {
            "y": 1.63
        },
        {
            "y": 1.67
        },
        {
            "y": 1.71
        },
        {
            "y": 1.74
        },
        {
            "y": 1.78
        },
        {
            "y": 1.83
        },
        {
            "y": 1.87
        },
        {
            "y": 1.92
        },
        {
            "y": 1.96
        },
        {
            "y": 2
        },
        {
            "y": 2.05
        },
        {
            "y": 2.1
        },
        {
            "y": 2.14
        },
        {
            "y": 2.2
        },
        {
            "y": 2.25
        },
        {
            "y": 2.31
        },
        {
            "y": 2.36
        },
        {
            "y": 2.41
        },
        {
            "y": 2.47
        },
        {
            "y": 2.52
        },
        {
            "y": 2.58
        },
        {
            "y": 2.64
        },
        {
            "y": 2.7
        },
        {
            "y": 2.78
        },
        {
            "y": 2.84
        },
        {
            "y": 2.9
        },
        {
            "y": 2.97
        },
        {
            "y": 3.04
        },
        {
            "y": 3.11
        },
        {
            "y": 3.18
        },
        {
            "y": 3.26
        },
        {
            "y": 3.33
        },
        {
            "y": 3.41
        },
        {
            "y": 3.49
        },
        {
            "y": 3.57
        },
        {
            "y": 3.66
        },
        {
            "y": 3.73
        },
        {
            "y": 3.83
        },
        {
            "y": 3.91
        },
        {
            "y": 4.01
        },
        {
            "y": 4.1
        },
        {
            "y": 4.2
        },
        {
            "y": 4.3
        },
        {
            "y": 4.4
        },
        {
            "y": 4.5
        },
        {
            "y": 4.6
        },
        {
            "y": 4.71
        },
        {
            "y": 4.83
        },
        {
            "y": 4.93
        },
        {
            "y": 5.05
        },
        {
            "y": 5.17
        },
        {
            "y": 5.29
        },
        {
            "y": 5.41
        },
        {
            "y": 5.54
        },
        {
            "y": 5.67
        },
        {
            "y": 5.8
        },
        {
            "y": 5.93
        },
        {
            "y": 6.08
        },
        {
            "y": 6.22
        },
        {
            "y": 6.36
        },
        {
            "y": 6.52
        },
        {
            "y": 6.67
        },
        {
            "y": 6.82
        },
        {
            "y": 6.98
        },
        {
            "y": 7.14
        },
        {
            "y": 7.31
        },
        {
            "y": 7.47
        },
        {
            "y": 7.68
        },
        {
            "y": 7.87
        },
        {
            "y": 8.03
        },
        {
            "y": 8.21
        },
        {
            "y": 8.4
        },
        {
            "y": 8.59
        },
        {
            "y": 8.78
        },
        {
            "y": 8.99
        },
        {
            "y": 9.21
        },
        {
            "y": 9.43
        },
        {
            "y": 9.67
        },
        {
            "y": 9.88
        },
        {
            "y": 10.1
        },
        {
            "y": 10.33
        },
        {
            "y": 10.58
        },
        {
            "y": 10.84
        },
        {
            "y": 11.07
        },
        {
            "y": 11.34
        },
        {
            "y": 11.62
        },
        {
            "y": 11.87
        },
        {
            "y": 12.17
        },
        {
            "y": 12.46
        },
        {
            "y": 12.75
        },
        {
            "y": 13.06
        },
        {
            "y": 13.35
        },
        {
            "y": 13.63
        },
        {
            "y": 13.96
        },
        {
            "y": 14.29
        },
        {
            "y": 14.63
        },
        {
            "y": 15
        },
        {
            "y": 15.36
        },
        {
            "y": 15.7
        },
        {
            "y": 16.05
        },
        {
            "y": 16.41
        },
        {
            "y": 16.81
        },
        {
            "y": 17.23
        },
        {
            "y": 17.62
        },
        {
            "y": 18.01
        },
        {
            "y": 18.44
        },
        {
            "y": 18.88
        },
        {
            "y": 19.36
        },
        {
            "y": 19.76
        },
        {
            "y": 20.24
        },
        {
            "y": 20.72
        },
        {
            "y": 21.21
        },
        {
            "y": 21.66
        },
        {
            "y": 22.21
        },
        {
            "y": 22.73
        },
        {
            "y": 23.28
        },
        {
            "y": 23.77
        },
        {
            "y": 24.37
        },
        {
            "y": 24.91
        },
        {
            "y": 25.54
        },
        {
            "y": 26.12
        },
        {
            "y": 26.66
        },
        {
            "y": 27.3
        },
        {
            "y": 27.99
        },
        {
            "y": 28.62
        },
        {
            "y": 29.26
        },
        {
            "y": 29.96
        },
        {
            "y": 30.71
        },
        {
            "y": 31.36
        },
        {
            "y": 32.11
        },
        {
            "y": 32.83
        },
        {
            "y": 33.66
        },
        {
            "y": 34.51
        },
        {
            "y": 35.28
        },
        {
            "y": 36.07
        },
        {
            "y": 36.93
        },
        {
            "y": 37.76
        },
        {
            "y": 38.71
        },
        {
            "y": 39.58
        },
        {
            "y": 40.53
        },
        {
            "y": 41.44
        },
        {
            "y": 42.42
        },
        {
            "y": 43.44
        },
        {
            "y": 44.41
        },
        {
            "y": 45.47
        },
        {
            "y": 46.42
        },
        {
            "y": 47.6
        },
        {
            "y": 48.73
        },
        {
            "y": 49.76
        },
        {
            "y": 51.01
        },
        {
            "y": 52.23
        },
        {
            "y": 53.4
        },
        {
            "y": 54.68
        },
        {
            "y": 55.98
        },
        {
            "y": 57.23
        },
        {
            "y": 58.6
        },
        {
            "y": 60
        },
        {
            "y": 61.51
        },
        {
            "y": 62.81
        },
        {
            "y": 64.3
        },
        {
            "y": 65.75
        },
        {
            "y": 67.41
        },
        {
            "y": 69.01
        },
        {
            "y": 70.56
        },
        {
            "y": 72.24
        },
        {
            "y": 73.97
        },
        {
            "y": 75.63
        },
        {
            "y": 77.43
        },
        {
            "y": 79.28
        },
        {
            "y": 81.05
        },
        {
            "y": 82.87
        },
        {
            "y": 84.97
        },
        {
            "y": 86.75
        },
        {
            "y": 88.94
        },
        {
            "y": 90.81
        },
        {
            "y": 93.11
        },
        {
            "y": 95.33
        },
        {
            "y": 97.6
        },
        {
            "y": 99.93
        },
        {
            "y": 102.17
        },
        {
            "y": 104.46
        },
        {
            "y": 107.1
        },
        {
            "y": 109.5
        },
        {
            "y": 111.96
        },
        {
            "y": 114.47
        },
        {
            "y": 117.36
        },
        {
            "y": 119.99
        },
        {
            "y": 123.03
        },
        {
            "y": 125.79
        },
        {
            "y": 128.78
        },
        {
            "y": 132.04
        },
        {
            "y": 134.81
        },
        {
            "y": 138.03
        },
        {
            "y": 141.12
        },
        {
            "y": 144.49
        },
        {
            "y": 148.14
        },
        {
            "y": 151.25
        },
        {
            "y": 155.07
        },
        {
            "y": 158.33
        },
        {
            "y": 162.33
        },
        {
            "y": 165.97
        },
        {
            "y": 169.7
        },
        {
            "y": 173.98
        },
        {
            "y": 177.89
        },
        {
            "y": 181.88
        },
        {
            "y": 186.21
        },
        {
            "y": 190.65
        },
        {
            "y": 195.47
        },
        {
            "y": 199.86
        },
        {
            "y": 204.34
        },
        {
            "y": 209.21
        },
        {
            "y": 213.9
        },
        {
            "y": 219
        },
        {
            "y": 224.23
        },
        {
            "y": 229.57
        },
        {
            "y": 234.72
        },
        {
            "y": 239.99
        },
        {
            "y": 246.39
        },
        {
            "y": 251.92
        },
        {
            "y": 257.57
        },
        {
            "y": 264.08
        },
        {
            "y": 270
        },
        {
            "y": 276.06
        },
        {
            "y": 282.64
        },
        {
            "y": 288.98
        },
        {
            "y": 295.87
        },
        {
            "y": 302.93
        },
        {
            "y": 310.15
        },
        {
            "y": 317.11
        },
        {
            "y": 324.67
        },
        {
            "y": 332.41
        },
        {
            "y": 339.87
        },
        {
            "y": 347.49
        },
        {
            "y": 355.77
        },
        {
            "y": 364.76
        },
        {
            "y": 373.98
        },
        {
            "y": 381.84
        },
        {
            "y": 390.94
        },
        {
            "y": 399.71
        },
        {
            "y": 408.68
        },
        {
            "y": 418.42
        },
        {
            "y": 428.4
        },
        {
            "y": 438.01
        },
        {
            "y": 448.45
        },
        {
            "y": 459.15
        },
        {
            "y": 470.1
        },
        {
            "y": 479.98
        },
        {
            "y": 492.79
        },
        {
            "y": 503.14
        },
        {
            "y": 515.14
        },
        {
            "y": 527.42
        },
        {
            "y": 539.25
        },
        {
            "y": 552.88
        },
        {
            "y": 565.28
        },
        {
            "y": 577.96
        },
        {
            "y": 592.56
        },
        {
            "y": 605.79
        },
        {
            "y": 620.44
        },
        {
            "y": 633.94
        },
        {
            "y": 646.35
        },
        {
            "y": 657.75
        },
        {
            "y": 671.11
        },
        {
            "y": 682
        },
        {
            "y": 694.76
        },
        {
            "y": 706.53
        },
        {
            "y": 718.02
        },
        {
            "y": 728.6
        },
        {
            "y": 740.21
        },
        {
            "y": 749.68
        },
        {
            "y": 760.16
        },
        {
            "y": 770.41
        },
        {
            "y": 779.83
        },
        {
            "y": 789.62
        },
        {
            "y": 799.18
        },
        {
            "y": 807.97
        },
        {
            "y": 817.63
        },
        {
            "y": 826.54
        },
        {
            "y": 834.73
        },
        {
            "y": 842.25
        },
        {
            "y": 851.06
        },
        {
            "y": 859.19
        },
        {
            "y": 866.67
        },
        {
            "y": 874.43
        },
        {
            "y": 882.45
        },
        {
            "y": 888.56
        },
        {
            "y": 896.65
        },
        {
            "y": 902.9
        },
        {
            "y": 910.62
        },
        {
            "y": 916.58
        },
        {
            "y": 923.18
        },
        {
            "y": 929.62
        },
        {
            "y": 935.56
        },
        {
            "y": 941.72
        },
        {
            "y": 947.73
        },
        {
            "y": 953.61
        },
        {
            "y": 997.63
        },
        {
            "y": 999.31
        },
        {
            "y": 1000.42
        },
        {
            "y": 1004.26
        },
        {
            "y": 1008.82
        },
        {
            "y": 1013.01
        },
        {
            "y": 1017.37
        },
        {
            "y": 1021.62
        },
        {
            "y": 1025.53
        },
        {
            "y": 1029.6
        },
        {
            "y": 1033.33
        },
        {
            "y": 1037.89
        },
        {
            "y": 1040.79
        },
        {
            "y": 1044.71
        },
        {
            "y": 1048.12
        },
        {
            "y": 1051.45
        },
        {
            "y": 1055.11
        },
        {
            "y": 1058.48
        },
        {
            "y": 1061.78
        },
        {
            "y": 1064.81
        },
        {
            "y": 1067.96
        },
        {
            "y": 1071.04
        },
        {
            "y": 1073.87
        },
        {
            "y": 1076.97
        },
        {
            "y": 1079.67
        },
        {
            "y": 1082.48
        },
        {
            "y": 1084.89
        },
        {
            "y": 1087.73
        },
        {
            "y": 1090.19
        },
        {
            "y": 1092.75
        },
        {
            "y": 1095.25
        },
        {
            "y": 1097.69
        },
        {
            "y": 1099.93
        },
        {
            "y": 1102.13
        },
        {
            "y": 1104.41
        },
        {
            "y": 1106.63
        },
        {
            "y": 1108.68
        },
        {
            "y": 1110.81
        },
        {
            "y": 1113.01
        },
        {
            "y": 1114.92
        },
        {
            "y": 1116.9
        },
        {
            "y": 1118.72
        },
        {
            "y": 1120.61
        },
        {
            "y": 1122.36
        },
        {
            "y": 1124.27
        },
        {
            "y": 1125.83
        },
        {
            "y": 1127.55
        },
        {
            "y": 1129.34
        },
        {
            "y": 1130.89
        },
        {
            "y": 1132.5
        },
        {
            "y": 1133.98
        },
        {
            "y": 1135.61
        },
        {
            "y": 1136.93
        },
        {
            "y": 1138.4
        },
        {
            "y": 1139.84
        },
        {
            "y": 1141.16
        },
        {
            "y": 1142.61
        },
        {
            "y": 1143.87
        },
        {
            "y": 1145.17
        },
        {
            "y": 1146.45
        },
        {
            "y": 1147.62
        },
        {
            "y": 1148.92
        },
        {
            "y": 1149.97
        },
        {
            "y": 1151.13
        },
        {
            "y": 1152.27
        },
        {
            "y": 1153.32
        },
        {
            "y": 1154.4
        },
        {
            "y": 1155.47
        },
        {
            "y": 1156.44
        },
        {
            "y": 1157.52
        },
        {
            "y": 1158.45
        },
        {
            "y": 1159.47
        },
        {
            "y": 1160.25
        },
        {
            "y": 1161.23
        },
        {
            "y": 1162.08
        },
        {
            "y": 1163.02
        },
        {
            "y": 1163.78
        },
        {
            "y": 1164.67
        },
        {
            "y": 1165.49
        },
        {
            "y": 1166.25
        },
        {
            "y": 1167.04
        },
        {
            "y": 1167.89
        },
        {
            "y": 1168.47
        },
        {
            "y": 1169.24
        },
        {
            "y": 1169.92
        },
        {
            "y": 1170.62
        },
        {
            "y": 1171.3
        },
        {
            "y": 1171.97
        },
        {
            "y": 1172.59
        },
        {
            "y": 1173.22
        },
        {
            "y": 1173.81
        },
        {
            "y": 1174.46
        },
        {
            "y": 1175.02
        },
        {
            "y": 1175.57
        },
        {
            "y": 1176.17
        },
        {
            "y": 1176.69
        },
        {
            "y": 1177.2
        },
        {
            "y": 1177.7
        },
        {
            "y": 1178.25
        },
        {
            "y": 1178.73
        },
        {
            "y": 1179.22
        },
        {
            "y": 1179.74
        },
        {
            "y": 1180.15
        },
        {
            "y": 1180.62
        },
        {
            "y": 1181.07
        },
        {
            "y": 1181.48
        },
        {
            "y": 1181.91
        },
        {
            "y": 1182.34
        },
        {
            "y": 1182.75
        },
        {
            "y": 1183.12
        },
        {
            "y": 1183.52
        },
        {
            "y": 1183.92
        },
        {
            "y": 1184.26
        },
        {
            "y": 1184.62
        },
        {
            "y": 1184.96
        },
        {
            "y": 1185.31
        },
        {
            "y": 1185.65
        },
        {
            "y": 1185.99
        },
        {
            "y": 1186.29
        },
        {
            "y": 1186.61
        },
        {
            "y": 1186.92
        },
        {
            "y": 1187.23
        },
        {
            "y": 1187.51
        },
        {
            "y": 1187.82
        },
        {
            "y": 1188.08
        },
        {
            "y": 1188.35
        },
        {
            "y": 1188.62
        },
        {
            "y": 1188.88
        },
        {
            "y": 1189.11
        },
        {
            "y": 1189.36
        },
        {
            "y": 1189.63
        },
        {
            "y": 1189.88
        },
        {
            "y": 1190.09
        },
        {
            "y": 1190.32
        },
        {
            "y": 1190.53
        },
        {
            "y": 1190.75
        },
        {
            "y": 1190.97
        },
        {
            "y": 1191.18
        },
        {
            "y": 1191.37
        },
        {
            "y": 1191.57
        },
        {
            "y": 1191.77
        },
        {
            "y": 1191.96
        },
        {
            "y": 1192.13
        },
        {
            "y": 1192.32
        },
        {
            "y": 1192.51
        },
        {
            "y": 1192.65
        },
        {
            "y": 1192.9
        },
        {
            "y": 1193.07
        },
        {
            "y": 1193.22
        },
        {
            "y": 1193.38
        },
        {
            "y": 1193.53
        },
        {
            "y": 1193.68
        },
        {
            "y": 1193.82
        },
        {
            "y": 1193.97
        },
        {
            "y": 1194.11
        },
        {
            "y": 1194.23
        },
        {
            "y": 1194.36
        },
        {
            "y": 1194.49
        },
        {
            "y": 1194.62
        },
        {
            "y": 1194.75
        },
        {
            "y": 1194.86
        },
        {
            "y": 1194.99
        },
        {
            "y": 1195.1
        },
        {
            "y": 1195.21
        },
        {
            "y": 1195.32
        },
        {
            "y": 1195.43
        },
        {
            "y": 1195.53
        },
        {
            "y": 1195.63
        },
        {
            "y": 1195.73
        },
        {
            "y": 1195.83
        },
        {
            "y": 1195.92
        },
        {
            "y": 1196.03
        },
        {
            "y": 1196.11
        },
        {
            "y": 1196.2
        },
        {
            "y": 1196.29
        },
        {
            "y": 1196.37
        },
        {
            "y": 1196.46
        },
        {
            "y": 1196.54
        },
        {
            "y": 1196.62
        },
        {
            "y": 1196.69
        },
        {
            "y": 1196.77
        },
        {
            "y": 1196.84
        },
        {
            "y": 1196.92
        },
        {
            "y": 1196.99
        },
        {
            "y": 1197.06
        },
        {
            "y": 1197.12
        },
        {
            "y": 1197.19
        },
        {
            "y": 1197.25
        },
        {
            "y": 1197.32
        },
        {
            "y": 1197.38
        },
        {
            "y": 1197.44
        },
        {
            "y": 1197.5
        },
        {
            "y": 1197.55
        },
        {
            "y": 1197.61
        },
        {
            "y": 1197.66
        },
        {
            "y": 1197.71
        },
        {
            "y": 1197.77
        },
        {
            "y": 1197.82
        },
        {
            "y": 1197.87
        },
        {
            "y": 1197.92
        },
        {
            "y": 1197.97
        },
        {
            "y": 1198.02
        },
        {
            "y": 1198.06
        },
        {
            "y": 1198.1
        },
        {
            "y": 1198.14
        },
        {
            "y": 1198.19
        },
        {
            "y": 1198.23
        },
        {
            "y": 1198.27
        },
        {
            "y": 1198.31
        },
        {
            "y": 1198.35
        },
        {
            "y": 1198.38
        },
        {
            "y": 1198.43
        },
        {
            "y": 1198.46
        },
        {
            "y": 1198.49
        },
        {
            "y": 1198.53
        },
        {
            "y": 1198.56
        },
        {
            "y": 1198.59
        },
        {
            "y": 1198.63
        },
        {
            "y": 1198.66
        },
        {
            "y": 1198.69
        },
        {
            "y": 1198.72
        },
        {
            "y": 1198.75
        },
        {
            "y": 1198.78
        },
        {
            "y": 1198.81
        },
        {
            "y": 1198.83
        },
        {
            "y": 1198.86
        },
        {
            "y": 1198.89
        },
        {
            "y": 1198.91
        },
        {
            "y": 1198.93
        },
        {
            "y": 1198.96
        },
        {
            "y": 1198.98
        },
        {
            "y": 1199.01
        },
        {
            "y": 1199.03
        },
        {
            "y": 1199.05
        },
        {
            "y": 1199.07
        },
        {
            "y": 1199.09
        },
        {
            "y": 1199.12
        },
        {
            "y": 1199.13
        },
        {
            "y": 1199.16
        },
        {
            "y": 1199.17
        },
        {
            "y": 1199.19
        },
        {
            "y": 1199.21
        },
        {
            "y": 1199.23
        },
        {
            "y": 1199.25
        },
        {
            "y": 1199.26
        },
        {
            "y": 1199.28
        },
        {
            "y": 1199.3
        },
        {
            "y": 1199.31
        },
        {
            "y": 1199.33
        },
        {
            "y": 1199.34
        },
        {
            "y": 1199.36
        },
        {
            "y": 1199.38
        },
        {
            "y": 1199.39
        },
        {
            "y": 1199.4
        },
        {
            "y": 1200
        }
    ],

  plane:
      [
          {
              "y": 0
          },
          {
              "y": -0.05
          },
          {
              "y": -0.05
          },
          {
              "y": -0.06
          },
          {
              "y": -0.06
          },
          {
              "y": -0.06
          },
          {
              "y": -0.07
          },
          {
              "y": -0.07
          },
          {
              "y": -0.08
          },
          {
              "y": -0.08
          },
          {
              "y": -0.08
          },
          {
              "y": -0.09
          },
          {
              "y": -0.09
          },
          {
              "y": -0.1
          },
          {
              "y": -0.11
          },
          {
              "y": -0.11
          },
          {
              "y": -0.12
          },
          {
              "y": -0.13
          },
          {
              "y": -0.14
          },
          {
              "y": -0.15
          },
          {
              "y": -0.15
          },
          {
              "y": -0.16
          },
          {
              "y": -0.17
          },
          {
              "y": -0.18
          },
          {
              "y": -0.19
          },
          {
              "y": -0.2
          },
          {
              "y": -0.22
          },
          {
              "y": -0.23
          },
          {
              "y": -0.24
          },
          {
              "y": -0.25
          },
          {
              "y": -0.27
          },
          {
              "y": -0.29
          },
          {
              "y": -0.3
          },
          {
              "y": -0.32
          },
          {
              "y": -0.34
          },
          {
              "y": -0.36
          },
          {
              "y": -0.38
          },
          {
              "y": -0.41
          },
          {
              "y": -0.43
          },
          {
              "y": -0.45
          },
          {
              "y": -0.48
          },
          {
              "y": -0.51
          },
          {
              "y": -0.54
          },
          {
              "y": -0.57
          },
          {
              "y": -0.61
          },
          {
              "y": -0.64
          },
          {
              "y": -0.68
          },
          {
              "y": -0.72
          },
          {
              "y": -0.76
          },
          {
              "y": -0.81
          },
          {
              "y": -0.86
          },
          {
              "y": -0.9
          },
          {
              "y": -0.96
          },
          {
              "y": -1.01
          },
          {
              "y": -1.07
          },
          {
              "y": -1.14
          },
          {
              "y": -1.21
          },
          {
              "y": -1.28
          },
          {
              "y": -1.36
          },
          {
              "y": -1.44
          },
          {
              "y": -1.53
          },
          {
              "y": -1.61
          },
          {
              "y": -1.71
          },
          {
              "y": -1.81
          },
          {
              "y": -1.92
          },
          {
              "y": -2.03
          },
          {
              "y": -2.16
          },
          {
              "y": -2.28
          },
          {
              "y": -2.42
          },
          {
              "y": -2.56
          },
          {
              "y": -2.72
          },
          {
              "y": -2.89
          },
          {
              "y": -3.06
          },
          {
              "y": -3.22
          },
          {
              "y": -3.43
          },
          {
              "y": -3.65
          },
          {
              "y": -3.86
          },
          {
              "y": -4.07
          },
          {
              "y": -4.48
          },
          {
              "y": -4.56
          },
          {
              "y": -4.82
          },
          {
              "y": -5.11
          },
          {
              "y": -5.42
          },
          {
              "y": -5.75
          },
          {
              "y": -6.08
          },
          {
              "y": -6.72
          },
          {
              "y": -7.13
          },
          {
              "y": -7.54
          },
          {
              "y": -7.99
          },
          {
              "y": -8.45
          },
          {
              "y": -8.96
          },
          {
              "y": -9.51
          },
          {
              "y": -10.08
          },
          {
              "y": -10.69
          },
          {
              "y": -10.88
          },
          {
              "y": -11.5
          },
          {
              "y": -12.2
          },
          {
              "y": -12.94
          },
          {
              "y": -13.73
          },
          {
              "y": -14.56
          },
          {
              "y": -15.34
          },
          {
              "y": -16.27
          },
          {
              "y": -17.31
          },
          {
              "y": -18.36
          },
          {
              "y": -19.41
          },
          {
              "y": -20.59
          },
          {
              "y": -21.84
          },
          {
              "y": -23.08
          },
          {
              "y": -24.4
          },
          {
              "y": -25.97
          },
          {
              "y": -27.55
          },
          {
              "y": -29.22
          },
          {
              "y": -30.99
          },
          {
              "y": -32.76
          },
          {
              "y": -34.63
          },
          {
              "y": -36.73
          },
          {
              "y": -39.09
          },
          {
              "y": -41.47
          },
          {
              "y": -43.83
          },
          {
              "y": -46.33
          },
          {
              "y": -49.14
          },
          {
              "y": -52.04
          },
          {
              "y": -54.62
          },
          {
              "y": -56.92
          },
          {
              "y": -59.95
          },
          {
              "y": -61.84
          },
          {
              "y": -64.03
          },
          {
              "y": -65.97
          },
          {
              "y": -67.91
          },
          {
              "y": -69.75
          },
          {
              "y": -71.28
          },
          {
              "y": -72.93
          },
          {
              "y": -74.47
          },
          {
              "y": -76.02
          },
          {
              "y": -77.39
          },
          {
              "y": -78.61
          },
          {
              "y": -79.83
          },
          {
              "y": -80.92
          },
          {
              "y": -82.01
          },
          {
              "y": -83.16
          },
          {
              "y": -83.96
          },
          {
              "y": -84.82
          },
          {
              "y": -85.79
          },
          {
              "y": -86.51
          },
          {
              "y": -87.24
          },
          {
              "y": -87.97
          },
          {
              "y": -88.7
          },
          {
              "y": -89.31
          },
          {
              "y": -89.95
          },
          {
              "y": -90.46
          },
          {
              "y": -90.98
          },
          {
              "y": -91.49
          },
          {
              "y": -91.98
          },
          {
              "y": -92.44
          },
          {
              "y": -92.85
          },
          {
              "y": -93.25
          },
          {
              "y": -93.68
          },
          {
              "y": -93.98
          },
          {
              "y": -94.33
          },
          {
              "y": -94.63
          },
          {
              "y": -94.94
          },
          {
              "y": -95.23
          },
          {
              "y": -95.49
          },
          {
              "y": -95.73
          },
          {
              "y": -95.98
          },
          {
              "y": -96.22
          },
          {
              "y": -96.41
          },
          {
              "y": -96.63
          },
          {
              "y": -96.81
          },
          {
              "y": -96.99
          },
          {
              "y": -97.15
          },
          {
              "y": -97.33
          },
          {
              "y": -97.47
          },
          {
              "y": -97.61
          },
          {
              "y": -97.75
          },
          {
              "y": -97.87
          },
          {
              "y": -98
          },
          {
              "y": -98.11
          },
          {
              "y": -98.21
          },
          {
              "y": -98.31
          },
          {
              "y": -98.4
          },
          {
              "y": -98.5
          },
          {
              "y": -98.58
          },
          {
              "y": -98.66
          },
          {
              "y": -98.74
          },
          {
              "y": -98.81
          },
          {
              "y": -98.88
          },
          {
              "y": -98.94
          },
          {
              "y": -99
          },
          {
              "y": -99.05
          },
          {
              "y": -99.11
          },
          {
              "y": -99.16
          },
          {
              "y": -99.21
          },
          {
              "y": -99.25
          },
          {
              "y": -99.3
          },
          {
              "y": -99.33
          },
          {
              "y": -99.37
          },
          {
              "y": -99.41
          },
          {
              "y": -99.44
          },
          {
              "y": -99.47
          },
          {
              "y": -99.5
          },
          {
              "y": -99.53
          },
          {
              "y": -99.55
          },
          {
              "y": -99.58
          },
          {
              "y": -99.6
          },
          {
              "y": -99.63
          },
          {
              "y": -99.65
          },
          {
              "y": -99.67
          },
          {
              "y": -99.68
          },
          {
              "y": -99.7
          },
          {
              "y": -99.72
          },
          {
              "y": -99.74
          },
          {
              "y": -99.75
          },
          {
              "y": -99.76
          },
          {
              "y": -99.78
          },
          {
              "y": -99.79
          },
          {
              "y": -99.8
          },
          {
              "y": -99.81
          },
          {
              "y": -99.82
          },
          {
              "y": -99.84
          },
          {
              "y": -99.84
          },
          {
              "y": -99.85
          },
          {
              "y": -99.86
          },
          {
              "y": -99.87
          },
          {
              "y": -99.88
          },
          {
              "y": -99.88
          },
          {
              "y": -99.89
          },
          {
              "y": -99.89
          },
          {
              "y": -99.9
          },
          {
              "y": -99.91
          },
          {
              "y": -99.91
          },
          {
              "y": -99.92
          },
          {
              "y": -99.92
          },
          {
              "y": -99.93
          },
          {
              "y": -99.93
          },
          {
              "y": -99.93
          },
          {
              "y": -99.94
          },
          {
              "y": -99.94
          },
          {
              "y": -99.94
          },
          {
              "y": -99.95
          },
          {
              "y": -99.95
          },
          {
              "y": -100
          }
      ]
}



